class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawer = this;

    // If url has cart=1 open by default
    if (window.location.search.includes('cart=1')) {
      this.open();
    }

    this.removeAllButton = this.querySelector('#CartDrawer-RemoveAll');

    if (this.removeAllButton) {
      this.removeAllButton.addEventListener('click', this.removeAll.bind(this));
    }

    this.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close()
    );
    const overlay = this.querySelector('#CartDrawer-Overlay') || document.querySelector('#CartDrawer-Overlay');
    overlay.addEventListener(
      'click',
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink?.setAttribute('role', 'button');
    cartLink?.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');

    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    setTimeout(() => {
      this.classList.add('active');
      this.drawer.classList.add('drawer--opened');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('CartDrawer');
        const focusElement =
          this.querySelector('.drawer__container') ||
          this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    if(window.DY && window.DY.recommendationContext) {
      let cartSkus = JSON.parse(this.querySelector('[type="application/json"]').textContent);
   
      DY.recommendationContext = {
        type: 'CART',
        data: cartSkus,
        lng: window.theme.locale
      };
    }
  }

  close() {
    this.classList.remove('drawer--opened');
    this.classList.remove('active');

    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');

    if (window.DY) {
      const template = window.theme.template_name;

      if (template === "collection") {
        DY.recommendationContext = {
          type: "CATEGORY",
          data: [window.dyCollection.title],
          lng: window.theme.locale,
        };
      } else if (template === "product") {
        DY.recommendationContext = {
          type: "PRODUCT",
          data: [window.dyProduct.sku],
          lng: window.theme.locale,
        };
      } else {
        DY.recommendationContext = {
          type: template === "index" ? "HOMEPAGE" : "OTHER",
          lng: window.theme.locale,
        };
      }
    }

  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote?.setAttribute('role', 'button');
    cartDrawerNote?.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote?.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget?.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__container').classList.contains('is-empty') &&
      this.querySelector('.drawer__container').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay') || document.querySelector('#CartDrawer-Overlay');
      overlay.addEventListener(
        'click',
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
        selector: '.cart-count-bubble__count',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  fullUpdate(open = false) {
    return fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        this.querySelector('.drawer__container').innerHTML =
          html.querySelector('.drawer__container').innerHTML;

        if (open) {
          this.open();
        }
      });
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__content',
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__heading',
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__footer',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.cart-count-bubble__count',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

